import React from 'react';
import withData from '../../../../core/containers/withData';
import Box from '../../../../components/Box';
import Spinner from '../../../../components/Spinner';
import { buildStatsRow } from '../../../../utils';
import './PlayersListItemStats.css';

class PlayersListItemStats extends React.Component {
  renderRows() {
    const { data, playerId } = this.props;

    if (!data || !data.length) {
      return null;
    }

    let filteredDataByPlayerId = data.filter(row => row.player_id === playerId)
      , rows = []
      , keys = [];

    if (this.props.showPlayersStatsWonGames) { keys.push('won'); }
    if (this.props.showPlayersStatsLostGames) { keys.push('lost'); }
    if (this.props.showPlayersStatsHomeGames) { keys.push('home'); }
    if (this.props.showPlayersStatsAwayGames) { keys.push('away'); }
    if (this.props.showPlayersStatsAllGames) { keys.push('all'); }
    if (this.props.showPlayersStatsTotal) { keys.push('total'); }

    keys.map(key => {
      let row = filteredDataByPlayerId.filter(r => r.row_type === key)[0];

      if (!row) {
        return null;
      }

      buildStatsRow(row);

      return rows.push(
        <tr key={ key }>
          <td>
            { key === 'home' && <strong className="text-primary">Home</strong> }
            { key === 'away' && <strong className="text-muted">Away</strong> }
            { key === 'won' && <strong className="text-success">Won</strong> }
            { key === 'lost' && <strong className="text-danger">Lost</strong> }
            { key === 'all' && <strong>All</strong> }
            { key === 'total' && <strong>Total</strong> }

          </td>
          <td>{ row.count }</td>
          <td>{ row.started }</td>
          <td>{ row.minutes }</td>
          <td>{ row.points.toFixed(1) }</td>
          <td>{ row.fg_made.toFixed(1) }</td>
          <td>{ row.fg_attempts.toFixed(1) }</td>
          <td>{ row.fg_percent.toFixed(1) }</td>
          <td>{ row.p3_made.toFixed(1) }</td>
          <td>{ row.p3_attempts.toFixed(1) }</td>
          <td>
            <span className={ row.p3_percent > 37 ? 'marked-high' : '' }>
              { row.p3_percent.toFixed(1) }
            </span>
          </td>
          <td>{ row.p2_made.toFixed(1) }</td>
          <td>{ row.p2_attempts.toFixed(1) }</td>
          <td>
            <span className={ row.p2_percent > 60 ? 'marked-high' : '' }>
              { row.p2_percent.toFixed(1) }
            </span>
          </td>
          <td>{ row.ft_made.toFixed(1) }</td>
          <td>
            <span className={ key !== 'total' && row.ft_attempts > 5 ? 'marked-high' : '' }>
              { row.ft_attempts.toFixed(1) }
            </span>
          </td>
          <td>
            <span className={ row.ft_percent && row.ft_percent < 65 ? 'marked-low' : '' }>
              { row.ft_percent.toFixed(1) }
            </span>
          </td>
          <td>
            <span className={ key !== 'total' && row.of_rebounds > 1.5 ? 'marked-high' : '' }>
              { row.of_rebounds.toFixed(1) }
            </span>
          </td>
          <td>{ row.df_rebounds.toFixed(1) }</td>
          <td>
            <span className={ key !== 'total' && row.assists > 3 ? 'marked-high' : '' }>
              { row.assists.toFixed(1) }
            </span>
          </td>
          <td>
            <span className={ key !== 'total' && row.turnovers > 2 ? 'marked-low' : '' }>
              { row.turnovers.toFixed(1) }
            </span>
          </td>
          <td>
            <span className={ key !== 'total' && row.steals > 1.5 ? 'marked-high' : '' }>
              { row.steals.toFixed(1) }
            </span>
          </td>
          <td>{ row.block_shots.toFixed(1) }</td>
          <td>{ row.shots_rejected.toFixed(1) }</td>
          <td>{ row.fouls_made.toFixed(1) }</td>
          <td>{ row.fouls_received.toFixed(1) }</td>
          <td>{ key === 'total' ? (row.count ? (row.vir / row.count) : 0).toFixed(2) : row.vir.toFixed(2) }</td>
          <td>{ row.oer.toFixed(2) }</td>
          <td>{ key === 'total' ? (row.count ? (row.val / row.count) : 0).toFixed(1) : row.val.toFixed(1) }</td>
        </tr>
      );
    });

    return rows;
  }

  render() {
    const { isFetching } = this.props;

    return (
      <Box className="table-responsive player-list-item-stats">
        { isFetching && <Spinner /> }
        <table className="table table-bordered table-hover table-stats">
        <tbody>
          <tr>
            <th></th>
            <th>GP</th>
            <th>GS</th>
            <th>MIN</th>
            <th>PTS</th>
            <th>FG</th>
            <th>FGA</th>
            <th>FG%</th>
            <th>3P</th>
            <th>3PA</th>
            <th>3P%</th>
            <th>2P</th>
            <th>2PA</th>
            <th>2P%</th>
            <th>FT</th>
            <th>FTA</th>
            <th>FT%</th>
            <th>OR</th>
            <th>DR</th>
            <th>AS</th>
            <th>TO</th>
            <th>ST</th>
            <th>BS</th>
            <th>SR</th>
            <th>FM</th>
            <th>FR</th>
            <th>VIR</th>
            <th>OER</th>
            <th>VAL</th>
          </tr>
          { this.renderRows() }
        </tbody>
        </table>
      </Box>
    );
  }
};

export default withData(PlayersListItemStats);



// WEBPACK FOOTER //
// ./src/features/scout-report/components/PlayersListItemStats/PlayersListItemStats.js